import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import cacheManager from '../CacheManager';
import { formatDateTime, formatDate, formatTime } from '../js/dateFormatter';

const PgRelFaturasCanceladas = () => {
  
  const [clientesByIdCache, setClientesByIdCache] = useState({});
  const [itensByIdCache, setItensByIdCache] = useState({});
  
  const [Faturas, setFaturas] = useState([]);

  const [paginaAtual, setPaginaAtual] = useState(1);
  const FaturasPorPagina = 10;
  const [termoDeBusca, setTermoDeBusca] = useState('');
  const [FaturasFiltrados, setFaturasFiltrados] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const search = async () => {
    try {
      setIsLoading(true);

      const clientesByIdCache = await cacheManager.getClientesById()
      setClientesByIdCache(clientesByIdCache);
      const itensByIdCache = await cacheManager.getItensById()
      setItensByIdCache(itensByIdCache);
      const FaturasCache = await cacheManager.getFaturasCache();
      setFaturas(FaturasCache);

    } catch (error) {
      console.error('Erro ao buscar Faturas:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Estilos para esmaecer a página
  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 2, // Garanta que esteja acima de outros elementos da página
    display: isLoading ? 'block' : 'none', // Mostra apenas quando está carregando
  };

  useEffect(() => {
    search(); // Chama a função search ao montar o componente
  }, []); // O array vazio como segundo argumento garante que o efeito seja executado apenas uma vez, na montagem do componente

  useEffect(() => {
    const FaturasOrdenados = [...Faturas].sort((a, b) => {
      const idA = a.id_fatura;
      const idB = b.id_fatura;

      return idB - idA;
    });

    const FaturasFiltrados = FaturasOrdenados.filter(fatura => {
      if(fatura.situacao !== 'Cancelada') return false; 
      let nomeCliente = clientesByIdCache[fatura.id_cliente]?.nome || ''
      nomeCliente = nomeCliente.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()
      return nomeCliente.includes(termoDeBusca.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase());
    });

    setFaturasFiltrados(FaturasFiltrados);
    setPaginaAtual(1);
  }, [Faturas, termoDeBusca]);

  return (
    <div className="container mt-5">
      {isLoading && <div style={overlayStyle}></div>}
      <h2 className="mb-4">Faturas</h2>
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Buscar..."
          id="search-input"
          value={termoDeBusca}
          onChange={(e) => setTermoDeBusca(e.target.value)}
        />
        <button className="btn btn-outline-secondary" type="button" onClick={search}>Buscar</button>
      </div>
      <table className="table">
        <thead className="table-light">
          <tr>
            <th>Nº</th>
            <th>Cliente</th>
            <th>Data</th>
            <th>Cancelamento</th>
            <th>Motivo</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
          {FaturasFiltrados.map((fatura, index) => (
            <tr key={index} style={{ height: 'auto !important', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              <td>
                <Link to={`/fatura/editar/${fatura.id_fatura}`} className="text-dark underline-on-hover">
                  {fatura.id_fatura}
                </Link>
              </td>
              <td>{clientesByIdCache[fatura.id_cliente]?.nome || 'Cliente não encontrado'}</td>
              <td>{formatDate(fatura.data_emissao)}</td>
              <td>{formatDate(fatura.data_cancelamento)}</td>
              <td>{fatura.motivo_cancelamento}</td>
              <td>R$ {fatura.valor_total}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PgRelFaturasCanceladas;